import React from "react";
import ModalV2 from "../../../../../shared/components/modalV2";
import { BLACK_CLOSE_BTN } from "../../../../../assets";

function RenameModal({
  isOpen,
  onClose,
  name,
  setName,
  onClick,
}: {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  setName: (name: string) => void;
  onClick: () => void;
}) {
  return (
    <ModalV2
      isOpen={isOpen}
      isClose={onClose}
      maxWidth="w-[448px]"
      edges="rounded-xl"
    >
      <div className="w-full py-4 px-10 flex gap-y-2 flex-col items-end justify-end">
        <button onClick={onClose}>
          <img src={BLACK_CLOSE_BTN} className="w-[17px] h-[17px]" alt="" />
        </button>

        <div className="w-full flex flex-col gap-y-8">
          <span className="text-2xl font-semibold">Rename</span>
          <input
            type="text "
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter new name"
            className="w-full border border-[#CACACA] p-3  rounded outline-none"
          />
          <div className="w-full flex items-center gap-3 pb-5">
            <button
              onClick={onClose}
              className="w-full bg-[#E5E5E5] rounded p-3 text-[16px] font-medium text-[#515457]"
            >
              Cancel
            </button>
            <button
              onClick={onClick}
              className="w-full bg-[#217834] rounded p-3 text-[16px] font-medium text-white"
            >
              Rename
            </button>
          </div>
        </div>
      </div>
    </ModalV2>
  );
}

export default RenameModal;
